import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import Promise from 'bluebird';
import camelCase from 'lodash/camelCase';

/**
 * Retries the given function when a network error is thrown.
 */
export function retryOnNetworkFailure(fn) {
  var retryCount = 0;
  var maxRetryCount = 5;
  var backoffTime = 300;
  var doneRetryingFn;
  var onFirstRetry;
  var valFromFirstRetry;
  var recoveredFn;
  var promise = Promise.try(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var run, lastError, result;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          run = /*#__PURE__*/function () {
            var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
              return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    _context.prev = 0;
                    _context.next = 3;
                    return fn();
                  case 3:
                    _context.t0 = _context.sent;
                    return _context.abrupt("return", {
                      result: _context.t0
                    });
                  case 7:
                    _context.prev = 7;
                    _context.t1 = _context["catch"](0);
                    if (!isNetworkError(_context.t1)) {
                      _context.next = 11;
                      break;
                    }
                    return _context.abrupt("return", {
                      error: _context.t1
                    });
                  case 11:
                    throw _context.t1;
                  case 12:
                  case "end":
                    return _context.stop();
                }
              }, _callee, null, [[0, 7]]);
            }));
            return function run() {
              return _ref2.apply(this, arguments);
            };
          }();
        case 1:
          if (!(retryCount < maxRetryCount)) {
            _context2.next = 21;
            break;
          }
          _context2.next = 4;
          return run();
        case 4:
          result = _context2.sent;
          if (!result.error) {
            _context2.next = 15;
            break;
          }
          lastError = result.error;
          retryCount++;
          if (!(retryCount === 1 && onFirstRetry)) {
            _context2.next = 12;
            break;
          }
          _context2.next = 11;
          return onFirstRetry(lastError);
        case 11:
          valFromFirstRetry = _context2.sent;
        case 12:
          _context2.next = 14;
          return Promise.delay(retryCount * backoffTime);
        case 14:
          return _context2.abrupt("continue", 1);
        case 15:
          if (!(retryCount > 0 && recoveredFn)) {
            _context2.next = 18;
            break;
          }
          _context2.next = 18;
          return recoveredFn(valFromFirstRetry);
        case 18:
          return _context2.abrupt("return", result.result);
        case 21:
          if (!doneRetryingFn) {
            _context2.next = 23;
            break;
          }
          return _context2.abrupt("return", doneRetryingFn(lastError, valFromFirstRetry));
        case 23:
          throw lastError;
        case 24:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  })));
  promise.retry = function (times) {
    maxRetryCount = times;
    return promise;
  };
  promise.firstRetry = function (fn) {
    onFirstRetry = fn;
    return promise;
  };
  promise.doneRetrying = function (fn) {
    doneRetryingFn = fn;
    return promise;
  };
  promise.backoffTime = function (time) {
    backoffTime = time;
    return promise;
  };
  promise.recovered = function (fn) {
    recoveredFn = fn;
    return promise;
  };
  return promise;
}
export function isNetworkError(error) {
  return error.message === 'Network Error' || error.message === 'Network Failure';
}
export function ignore404(err) {
  if (err.response && err.response.status === 404) return null;
  throw err;
}

/**
 * Whether the error indicates that we should try again.
 * DO NOT USE FOR NON-IDEMPOTENT EFFECTFUL REQUESTS
 *
 * @param {W} error
 */
export function isRetryableError(error) {
  if (isNetworkError(error)) {
    return true;
  }
  if (error.response && error.response.status === 412) {
    return true;
  }
  return false;
}
export function extractMessageFromError(err) {
  if (typeof err === 'string') {
    return err;
  }
  if (err.response) {
    return err.response.data ? err.response.data.errors && Array.isArray(err.response.data.errors) ? 'Validation errors: ' + err.response.data.errors.map(function (v) {
      return "".concat(v.field, " - ").concat(v.message);
    }).join(', ') : err.response.data.message : err.message;
  }
  return err.message;
}
export function rethrowRequestError(err) {
  if (err.response) {
    var message = extractMessageFromError(err);
    throw new Error(message);
  }
  throw err;
}
export function populateValidationContextFromError(context, err, modelFieldNameCasing) {
  var errors = err.response && err.response.data && err.response.data.errors || [];
  var mapped = {};
  errors.forEach(function (err) {
    var field = modelFieldNameCasing === 'camel' ? camelCase(err.field) : err.field;
    mapped[field] = [].concat(_toConsumableArray(mapped[field] || []), [err.message]);
  });
  context.addErrors(mapped);
  return err;
}
//# sourceMappingURL=errorUtil.js.map
